export const DEFAULT_LANG = "en";

export const SUPPORTED_LANGS = ["en", "fr", "de", "es", "pt"] as const;

export type SupportedLang = (typeof SUPPORTED_LANGS)[number];

export function isSupportedLang(lang: string | undefined): lang is SupportedLang {
  return !!lang && (SUPPORTED_LANGS as readonly string[]).includes(lang);
}

export function localizedPath(lang: string, path = "/"): string {
  const clean = path === "/" ? "" : path;
  if (lang === DEFAULT_LANG) {
    return clean || "/";
  }
  return `/${lang}${clean}`;
}

export function getLocalizedUrl(pathname: string, targetLang: string): string {
  const parts = pathname.split("/").filter(Boolean);
  if (parts.length > 0 && isSupportedLang(parts[0])) {
    parts.shift();
  }
  const rest = parts.join("/");
  return localizedPath(targetLang, rest ? `/${rest}` : "/");
}

export function isHomePathname(pathname: string): boolean {
  const parts = pathname.split("/").filter(Boolean);
  if (parts.length === 0) return true;
  if (parts.length === 1 && isSupportedLang(parts[0])) return true;
  return false;
}